import StepperBubble from '../StepperBubble/StepperBubble';
import './Stepper.scss';
import React from 'react';


const stepperOptions = [
    {name: 'Nueva Atención'},
    {name: 'Prestaciones'},
    {name: 'Crear Atención'},
    {name: 'Resumen'},
];


const Stepper = ({activeIndex, steps=stepperOptions}) => {
    return (
        <div className={'flex-aligned-justified-center stepper-container'}>
            {steps.map((option, index) => (
                <StepperBubble name={option.name} checked={index < activeIndex} number={index + 1} active={activeIndex === index}
                               withBar={index + 1 !== steps.length}/>
            ))}
        </div>
    );
};
export default Stepper;
